import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { secondsToHumanTime } from '../../../../utils/time';
import Beeper from '../../../general/Beeper';

const ElapsedTime = props => {
  const [elapsedTime, setElapsedTime] = useState(null);
  const [triggerSound, setTriggerSound] = useState(false);
  const [playSound, setPlaySound] = useState(false);
  const [alertedIncidentIds, setAlertedIncidentIds] = useState([]);
  const intervalRef = useRef(null);
  const startTimeMsRef = useRef(null);

  const clearTimer = () => {
    if (!intervalRef.current) return;
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const updateElapsedTime = () => {
    if (!startTimeMsRef.current) {
      setElapsedTime(null);
      return;
    }

    const nextElapsedTime = Math.max(0, Math.floor((Date.now() - startTimeMsRef.current) / 1000));
    setElapsedTime(previousElapsedTime =>
      previousElapsedTime === null ? nextElapsedTime : Math.max(previousElapsedTime, nextElapsedTime)
    );
  };

  const incidentAlreadyBeeped = alertedIncidentIds.includes(props.incidentId);
  const isBeyondTimeLimit = props.timeLimit ? moment().isSameOrAfter(props.timeLimit) : false;

  const onFinishedPlayingHandler = () => setPlaySound(false);

  useEffect(() => {
    const startTime = moment(props.startTime);
    if (!startTime.isValid()) {
      clearTimer();
      startTimeMsRef.current = null;
      setElapsedTime(null);
      return;
    }

    clearTimer();
    startTimeMsRef.current = startTime.valueOf();
    setElapsedTime(Math.max(0, Math.floor((Date.now() - startTimeMsRef.current) / 1000)));
    intervalRef.current = setInterval(updateElapsedTime, 1000);

    return clearTimer;
  }, [props.startTime]);

  useEffect(() => {
    return clearTimer;
  }, []);

  useEffect(() => {
    if (incidentAlreadyBeeped) return;
    if (isBeyondTimeLimit && !triggerSound) setTriggerSound(true);
    if (!isBeyondTimeLimit && triggerSound) setTriggerSound(false);
  }, [incidentAlreadyBeeped, isBeyondTimeLimit, triggerSound]);

  useEffect(() => {
    if (incidentAlreadyBeeped) return;

    if (triggerSound) setPlaySound(true);
  }, [triggerSound, incidentAlreadyBeeped]);

  useEffect(() => {
    if (!playSound || !props.incidentId) return;

    setAlertedIncidentIds(previousIncidentIds =>
      previousIncidentIds.includes(props.incidentId) ? previousIncidentIds : [...previousIncidentIds, props.incidentId]
    );
  }, [playSound, props.incidentId]);

  useEffect(() => {
    if (incidentAlreadyBeeped) setTriggerSound(false);
  }, [props.incidentId, incidentAlreadyBeeped]);

  if (elapsedTime === null) return null;

  const fontColor = isBeyondTimeLimit ? 'red' : 'var(--bs-body-color)';

  return (
    <>
      <Beeper playSound={playSound} onFinishedPlayingHandler={onFinishedPlayingHandler} />
      <h1 className="float-right display-4 fw-bold font-monospace" style={{ color: fontColor }}>
        {secondsToHumanTime(elapsedTime)}
      </h1>
    </>
  );
};

export default ElapsedTime;
